import React from "react";
import "./contact-banner.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';


function ContactBanner() {
return (

<div className="contact-banner">
    <div className="banner-left">
        
    <div className="banner-headline">
        Ready to make your selections?
        </div>
        <div className="banner-subheadline">
            We can help guide you through the process to choose the materials you'll love!

        </div>
        </div>
        <div className="banner-right">
            <a href="tel:2603213092" className="banner-button">
            <FontAwesomeIcon icon={faMobileAlt} />
               (260) 321-3092
            </a>
        </div>
</div>



);
}

export default ContactBanner